<app-modal #saveOptionsModal title="Save PolarLink Settings" [hasConfirmButton]="false" [hasCloseButton]="false">
	<div class="margin-bottom-sm">Do you want to apply changes immediately?</div>
	<div class="modal-footer padding-8">
		<button class="btn btn-primary" (click)="savePlinkSettings('direct');saveOptionsModal.hide()">OK</button>
		<button class="btn btn-warning" (click)="savePlinkSettings();saveOptionsModal.hide()">Queue It</button>
		<button class="btn btn-default" (click)="saveOptionsModal.hide()">Cancel</button>
	</div>
</app-modal>

<div *ngIf="userAccess && hasPlinks">
	<div *ngIf="isSet('CARDS')">
		<div class="row col-md-offset-0">
			<div style="background-image: url(./assets/images/RSE/POLARLINK_INFO_V2_364X367.png);" check-permission="POLARLINK-INFO" (click)="setTab('POLARLINK-INFO')" class="cards boxs3"></div>
			<div style="background-image: url(./assets/images/RSE/POLARLINK_SETTINGS_V2_347X348.png);" check-permission="POLARLINK-SETTINGS" (click)="setTab('POLARLINK-SETTINGS')" class="cards boxs3"></div>
			<div style="background-image: url(./assets/images/RSE/POLARLINK_WIFI_V2_339X340.png);" check-permission="WIFI" (click)="setTab('WIFI')" class="cards boxs3"></div>
			<div style="background-image: url(./assets/images/RSE/POLARLINK_CELLULAR.png);" check-permission="POLARLINK-CELLULAR" (click)="setTab('POLARLINK-CELLULAR')" class="cards boxs3"></div>
		</div>
	</div>

	<!-- POLARLINK INFO Section -->
	<div check-permission="POLARLINK-INFO" *ngIf="isSet('POLARLINK-INFO')">
		<div class="panel panel-default">
			<div class="panel-header">PolarLink Device Information</div>
			<div class="panel-body">
				<form name="plinkInfo">
					<div class="row">
						<div class="panel-body">
							<table class="cellpadding-10 col-xs-5">
								<!-- <tr check-permission="Plink_SN">
									<td class="col-md-4">{{'plink.customerid' |translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.customerid}" [pTooltip]="getStackHTML('rsesn')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_SN" type="text" class="form-control" [(ngModel)]="plink.customerid" name="customerid" maxlength="14"/>
									</td>
								</tr>
								<tr check-permission="Plink_SN">
									<td class="col-md-4">{{'plink.siteid' |translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.siteid}" [pTooltip]="getStackHTML('rsesn')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_SN" type="text" class="form-control" [(ngModel)]="plink.siteid" name="siteid" maxlength="14"/>
									</td>
								</tr> -->
								<tr check-permission="Plink_SN">
									<td class="col-md-4">{{'plink.rsesn' |translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.serialnumber}" [pTooltip]="getStackHTML('serialnumber')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_SN" type="text" class="form-control" [(ngModel)]="plink.serialnumber" name="serialnumber" maxlength="14"/>
									</td>
								</tr>
								<tr check-permission="Plink_HWRevision">
									<td class="col-md-4">{{'plink.hardware_revision' |translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.hwversion}" [pTooltip]="getStackHTML('hwversion')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_HWRevision" type="text" class="form-control" [(ngModel)]="plink.hwversion" name="hwversion" maxlength="2"/>
									</td>
								</tr>
								<tr check-permission="Plink_readFirmwareVersion">
									<td class="col-md-4">{{'plink.firmware_version' |translate}}</td>
									<td>
										<input check-permission="Plink_readFirmwareVersion" type="text" class="form-control" [(ngModel)]="plink.firmwareversion" name="firmwareversion" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_memorySignature">
									<td class="col-md-4">{{'plink.memory_signature' |translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.memorysignature}" [pTooltip]="getStackHTML('memorysignature')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_memorySignature" type="text" class="form-control" [(ngModel)]="plink.memorysignature" name="memorysignature" maxlength="5"/>
									</td>
								</tr>
								<tr>
									<td class="col-md-4">{{'plink.device_id' |translate}}</td>
									<td>
										<input type="text" class="form-control" [(ngModel)]="plink.deviceid" name="deviceid" readonly/>
									</td>
								</tr>
								<tr>
									<td class="col-md-4">{{'plink.installation_date' |translate}}</td>
									<td>
										<input type="text" class="form-control" [(ngModel)]="plink.installationdate" name="installationdate" readonly/>
									</td>
								</tr>
								<tr>
									<td class="col-md-4">{{'plink.last_change_user_id' |translate}}</td>
									<td>
										<input type="text" class="form-control" [(ngModel)]="plink.lastchangeuserid" name="lastchangeuserid" readonly/>
									</td>
								</tr>
								<tr>
									<td check-permission="SAVE-PLINK-INFO"><span class="save-btn" (click)="checkChanges('plinkInfo')">{{'g.save'| translate}}</span></td>
									<td><span class="back-btn" (click)="setTab('CARDS'); resetForms();">{{'g.back'| translate}}</span></td>
								</tr>
							</table>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>

	<!-- POLARLINK SETTINGS Section -->
	<div check-permission="POLARLINK-SETTINGS" *ngIf="isSet('POLARLINK-SETTINGS')">
		<div class="panel panel-default">
			<div class="panel-header">PolarLink Device Settings</div>
			<div class="panel-body"> 
				<form name="plinkSettings">
					<div class="row">
						<div class="panel-body">
							<table class="cellpadding-10 col-xs-5">
								<tr check-permission="Plink_RseID">
									<td class="col-md-4">{{'plink.rseid' |translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.rseid}" [pTooltip]="getStackHTML('rseid')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_RseID" type="text" class="form-control" [(ngModel)]="plink.rseid" name="rseid" maxlength="18"/>
									</td>
								</tr>
								<tr check-permission="Plink_TimeZone">
									<td class="col-md-4">{{'plink.timezone' |translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.zoneid}" [pTooltip]="getStackHTML('zoneid')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Plink_TimeZone" [(ngModel)]="plink.zoneid" class="form-control" name="zoneid">
											<option *ngFor="let zone of commonData.TimeZonesMenu" [ngValue]="zone.id">{{zone.display_name}}</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Plink_dayLightSaving_Enable">
									<td class="col-md-4">{{'plink.enable_day_light_savings' |translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.enabledaylightsaving}" [pTooltip]="getStackHTML('enabledaylightsaving')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Plink_dayLightSaving_Enable" [(ngModel)]="plink.enabledaylightsaving" class="form-control" name="enabledaylightsaving">
											<option [ngValue]="true">Enable</option>
											<option [ngValue]="false">Disable</option>
										</select>
									</td>
								</tr>
								<tr>
									<td check-permission="SAVE-PLINK-SETTINGS"><span class="save-btn" (click)="checkChanges('plinkSettings')">{{'g.save'| translate}}</span></td>
									<td><span class="back-btn" (click)="setTab('CARDS'); resetForms();">{{'g.back'| translate}}</span></td>
								</tr>
							</table>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>

	<!-- WIFI Section -->
	<div check-permission="WIFI" *ngIf="isSet('WIFI')">
		<div class="panel panel-default">
			<div class="panel-header">Polar Link WiFi Info</div>
			<div class="panel-body">
				<form name="wifi">
					<div class="row">
						<div class="panel-body">
							<table class="cellpadding-10 col-xs-5">
								<tr check-permission="Plink_mobileAccessSSID">
									<td class="col-md-4">{{'plink.mobile_ssid'| translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.mobileaccessssid}" [pTooltip]="getStackHTML('mobileaccessssid')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_mobileAccessSSID" type="text" class="form-control" [(ngModel)]="plink.mobileaccessssid" name="mobileaccessssid" maxlength="32"/>
									</td>
								</tr>
								<tr check-permission="Plink_mobileAccessSSIDPassword">
									<td class="col-md-4">{{'plink.mobile_ssid_pswd'| translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.mobileaccessssidpassword}" [pTooltip]="getStackHTML('mobileaccessssidpassword')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<div class="input-group">
											<input check-permission="Plink_mobileAccessSSIDPassword" [type]="mobilePassword ? 'text': 'password'" class="form-control" [(ngModel)]="plink.mobileaccessssidpassword" name="mobileaccessssidpassword" maxlength="14"/>
											<span class="input-group-btn"><button class="pswdBtn" check-permission="Plink_mobileAccessSSIDPassword"  (click)="mobilePassword = !mobilePassword" type="button"><i class="pi pi-eye eyeStyle"></i></button></span>
										</div>
									</td>
								</tr>
								<tr check-permission="Plink_mobilePort">
									<td class="col-md-4">{{'plink.mobile_ssid_port'| translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.mobileport}" [pTooltip]="getStackHTML('mobileport')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_mobilePort" type="text" class="form-control" [(ngModel)]="plink.mobileport" name="mobileport" maxlength="5"/>
									</td>
								</tr>
								<tr check-permission="Plink_actViewEnabled">
									<td class="col-md-4">{{'plink.actview_enabled' |translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actviewenabled}" [pTooltip]="getStackHTML('actviewenabled')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<label><input check-permission="Plink_actViewEnabled" type="radio" name="actviewenabled" [(ngModel)]="plink.actviewenabled" class="form-control" [value]="true"/> Enable</label>
										<label><input check-permission="Plink_actViewEnabled" type="radio" name="actviewenabled" [(ngModel)]="plink.actviewenabled" class="form-control" [value]="false"/> Disable</label>
									</td>
								</tr>
								<tr check-permission="Plink_actViewIP">
									<td class="col-md-4">{{'plink.actview_ip'| translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actviewip}" [pTooltip]="getStackHTML('actviewip')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_actViewIP" type="text" class="form-control" [(ngModel)]="plink.actviewip" name="actviewip" maxlength="32" [disabled]="!plink.actviewenabled"/>
									</td>
								</tr>
								<tr check-permission="Plink_actViewPort">
									<td class="col-md-4">{{'plink.actview_port'| translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actviewport}" [pTooltip]="getStackHTML('actviewport')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_actViewPort" type="text" class="form-control" [(ngModel)]="plink.actviewport" name="actviewport" maxlength="5" [disabled]="!plink.actviewenabled"/>
									</td>
								</tr>
								<tr check-permission="Plink_actViewConnectFrequency">
									<td class="col-md-4">{{'plink.actview_connect_freq'| translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actviewconnectfrequency}" [pTooltip]="getStackHTML('actviewconnectfrequency')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_actViewConnectFrequency" type="text" class="form-control" [(ngModel)]="plink.actviewconnectfrequency" name="actviewconnectfrequency" maxlength="5" [disabled]="!plink.actviewenabled"/>
									</td>
								</tr>
								<tr check-permission="Plink_actAccessSSID">
									<td class="col-md-4">{{'plink.actaccess_ssid'| translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actaccessssid}" [pTooltip]="getStackHTML('actaccessssid')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_actAccessSSID" type="text" class="form-control" [(ngModel)]="plink.actaccessssid" name="actaccessssid" maxlength="32" [disabled]="!plink.actviewenabled"/>
									</td>
								</tr>
								<tr check-permission="Plink_actAccessSSIDPassword">
									<td class="col-md-4">{{'plink.actaccess_ssid_pswd'| translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack.actaccessssidpassword}" [pTooltip]="getStackHTML('actaccessssidpassword')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<div class="input-group">
											<input check-permission="Plink_actAccessSSIDPassword" [type]="actAccessPassword ? 'text': 'password'" class="form-control" [(ngModel)]="plink.actaccessssidpassword" name="actaccessssidpassword" maxlength="32" [disabled]="!plink.actviewenabled"/>
											<span class="input-group-btn"><button class="pswdBtn" check-permission="Plink_actAccessSSIDPassword"  (click)="actAccessPassword = !actAccessPassword" type="button" [disabled]="!plink.actviewenabled"><i class="pi pi-eye eyeStyle"></i></button></span>
										</div>
									</td>
								</tr>
								<!-- <tr>
									<td class="col-md-6">Connection Status</td>
									<td>
										<input type="text" class="form-control" [(ngModel)]="plink.connectionstatus" name="connectionstatus" readonly/>
									</td>
								</tr>
								<tr>
									<td class="col-md-6">Signal Strength</td>
									<td>
										<input type="text" class="form-control" [(ngModel)]="plink.signalstrength" name="signalstrength" readonly/>
									</td>
								</tr> -->
								<!-- <tr *ngIf="currentUser.isACTuser && !isBulk">
									<td colspan="2">
										<fieldset>
											<legend>WiFi Info</legend>
											<table style="width:100%">
												<tr>
													<td class="col-md-6">AT Version</td>
													<td>
														{{plink.wifi_at_version}}
													</td>
												</tr>
												<tr>
													<td class="col-md-6">Local IP Address</td>
													<td>
														{{plink.wifi_local_ip}}
													</td>
												</tr>
												<tr>
													<td class="col-md-6">Gateway</td>
													<td>
														{{plink.wifi_gateway ? plink.wifi_gateway : 'Unsupported'}}
													</td>
												</tr>
												<tr>
													<td class="col-md-6">MAC Address</td>
													<td>
														{{plink.wifi_mac_address ? commonUtil.getHexMacAddress(plink.wifi_mac_address) : 'Unsupported'}}
													</td>
												</tr>
											</table>
										</fieldset>
									</td>
								</tr> -->
								<tr>
									<td check-permission="SAVE-POLARLINK-WIFI"><span class="save-btn" (click)="checkChanges('wifi')">{{'g.save'| translate}}</span></td>
									<td><span class="back-btn" (click)="setTab('CARDS'); resetForms();">{{'g.back'| translate}}</span></td>
								</tr>
							</table>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>

	<!-- POLARLINK Cellular Section -->
	<div check-permission="POLARLINK-CELLULAR" *ngIf="isSet('POLARLINK-CELLULAR')">
		<div class="panel panel-default">
			<div class="panel-header">PolarLink Cellular Settings</div>
			<div class="panel-body"> 
				<form name="plinkSettings">
					<div class="row">
						<div class="panel-body">
							<table class="cellpadding-10 col-xs-5">
								<tr check-permission="Plink_CellularactViewConnectFrequency">
									<td class="col-md-4">{{'plink.actview_connect_freq'| translate}}</td>
									<td [ngClass]="{'dirtySettingsField': changesStack?.cellularactviewconnectfrequency}" [pTooltip]="getStackHTML('cellularactviewconnectfrequency')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_CellularactViewConnectFrequency" type="text" class="form-control" [(ngModel)]="plink.data.cellularactviewconnectfrequency" name="cellularactviewconnectfrequency" maxlength="5" [disabled]="!plink.actviewenabled"/>
									</td>
								</tr>
								<tr check-permission="Plink_CellularType">
									<td class="col-md-4">{{'plink.cellular_type' |translate}}</td>
									<td [pTooltip]="getStackHTML('cellulartype')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Plink_CellularType" class="form-control" [(ngModel)]="plink.data.cellulartype" name="cellulartype" disabled>
											<option [value]="0">Cellular</option>
											<option [value]="1">CBRS</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Plink_ModemModel">
									<td class="col-md-4">{{'plink.modem_model' |translate}}</td>
									<td [pTooltip]="getStackHTML('modemmodel')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_ModemModel" type="text" class="form-control" [(ngModel)]="plink.data.modemmodel" name="modemmodel" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_ModemFWVer">
									<td class="col-md-4">{{'plink.modem_fw_ver' |translate}}</td>
									<td tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_ModemFWVer" type="text" class="form-control" [(ngModel)]="plink.data.modemfwversion" name="modemfwversion" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_ModemImei">
									<td class="col-md-4">{{'plink.modem_imei' |translate}}</td>
									<td [pTooltip]="getStackHTML('modemimei')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_ModemImei" type="text" class="form-control" [(ngModel)]="plink.data.modemimei" name="modemimei" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_ModemVendor">
									<td class="col-md-4">{{'plink.modem_vendor' |translate}}</td>
									<td [pTooltip]="getStackHTML('modemvendor')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_ModemVendor" type="text" class="form-control" [(ngModel)]="plink.data.modemvendor" name="modemvendor" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_ModemType">
									<td class="col-md-4">{{'plink.modem_type' |translate}}</td>
									<td [pTooltip]="getStackHTML('modemtype')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Plink_ModemType" class="form-control" [(ngModel)]="plink.data.modemtype" name="modemtype" disabled>
											<option [value]="0">Dongle</option>
											<option [value]="1">Chip</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Plink_ConnectedBand">
									<td class="col-md-4">{{'plink.connected_band' |translate}}</td>
									<td [pTooltip]="getStackHTML('connectedband')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_ConnectedBand" type="text" class="form-control" [(ngModel)]="plink.data.connectedband" name="connectedband" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_NetworkOperator">
									<td class="col-md-4">{{'plink.network_operator' |translate}}</td>
									<td [pTooltip]="getStackHTML('networkoperator')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_NetworkOperator" type="text" class="form-control" [(ngModel)]="plink.data.networkoperator" name="networkoperator" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_RSSI">
									<td class="col-md-4">{{'plink.RSSI' |translate}}</td>
									<td [pTooltip]="getStackHTML('rssi')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_RSSI" type="text" class="form-control" [(ngModel)]="plink.data.rssi" name="rssi" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_Sinr">
									<td class="col-md-4">{{'plink.SINR' |translate}}</td>
									<td [pTooltip]="getStackHTML('sinr')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_Sinr" type="text" class="form-control" [(ngModel)]="plink.data.sinr" name="sinr" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_RadioAccessType">
									<td class="col-md-4">{{'plink.radio_access_type' |translate}}</td>
									<td [pTooltip]="getStackHTML('radioaccesstype')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Plink_RadioAccessType" class="form-control" [(ngModel)]="plink.data.radioaccesstype" name="radioaccesstype" disabled>
											<option [value]="0">CAT-M</option>
											<option [value]="1">NB-IoT</option>
											<option [value]="2">LTE(4G)</option>
											<option [value]="3">NR-5G</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Plink_SimEid">
									<td class="col-md-4">{{'plink.sim_eid' |translate}}</td>
									<td [pTooltip]="getStackHTML('simeid')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_SimEid" type="text" class="form-control" [(ngModel)]="plink.data.simeid" name="simeid" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_SimIccid">
									<td class="col-md-4">{{'plink.sim_iccid' |translate}}</td>
									<td [pTooltip]="getStackHTML('simiccid')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_SimIccid" type="text" class="form-control" [(ngModel)]="plink.data.simiccid" name="simiccid" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_SimImsi">
									<td class="col-md-4">{{'plink.sim_imsi' |translate}}</td>
									<td [pTooltip]="getStackHTML('simimsi')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_SimImsi" type="text" class="form-control" [(ngModel)]="plink.data.simimsi" name="simimsi" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_Sim_Status">
									<td class="col-md-4">{{'plink.sim_status' |translate}}</td>
									<td [pTooltip]="getStackHTML('sim_status')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Plink_Sim_Status" class="form-control" [(ngModel)]="plink.data.sim_status" name="sim_status" disabled>
											<option [value]="0">Unknown</option>
											<option [value]="1">Ready</option>
											<option [value]="2">Locked</option>
											<option [value]="3">Not Detected</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Plink_LenApnInUse">
									<td class="col-md-4">{{'plink.len_apn_in_use' |translate}}</td>
									<td [pTooltip]="getStackHTML('len_apn_in_use')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_LenApnInUse" type="text" class="form-control" [(ngModel)]="plink.data.len_apn_in_use" name="len_apn_in_use" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_Apn_In_Use">
									<td class="col-md-4">{{'plink.apn_in_use' |translate}}</td>
									<td [pTooltip]="getStackHTML('apn_in_use')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_Apn_In_Use" type="text" class="form-control" [(ngModel)]="plink.data.apn_in_use" name="apn_in_use" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_Len_Apn_Configured">
									<td class="col-md-4">{{'plink.len_apn_configured' |translate}}</td>
									<td [pTooltip]="getStackHTML('len_apn_configured')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_Len_Apn_Configured" type="text" class="form-control" [(ngModel)]="plink.data.len_apn_configured" name="len_apn_configured" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_ApnConfigured">
									<td class="col-md-4">{{'plink.apn_configured' |translate}}</td>
									<td [pTooltip]="getStackHTML('apn_configured')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<input check-permission="Plink_ApnConfigured" type="text" class="form-control" [(ngModel)]="plink.data.apn_configured" name="apn_configured" readonly/>
									</td>
								</tr>
								<tr check-permission="Plink_RegistrationStatus">
									<td class="col-md-4">{{'plink.registration_status' |translate}}</td>
									<td [pTooltip]="getStackHTML('registration_status')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Plink_RegistrationStatus" class="form-control" [(ngModel)]="plink.data.registration_status" name="registration_status" disabled>
											<option [value]="0">Not Registered/Not Searching</option>
											<option [value]="1">Registered</option>
											<option [value]="2">Searching</option>
											<option [value]="3">Denied</option>
											<option [value]="4">Unknown</option>
											<option [value]="5">Roaming</option>
											<option [value]="8">Emergency Services</option>
										</select>
									</td>
								</tr>
								<tr check-permission="Plink_RFStatus">
									<td class="col-md-4">{{'plink.rf_status' |translate}}</td>
									<td [pTooltip]="getStackHTML('rf_status')" tooltipPosition="right" [escape]="false" tooltipStyleClass="device-changes-log">
										<select check-permission="Plink_RFStatus" class="form-control" [(ngModel)]="plink.data.rf_status" name="rf_status" disabled>
											<option [value]="0">Unknown</option>
											<option [value]="1">Detected</option>
										</select>
									</td>
								</tr>
								<tr>
									<td check-permission="SAVE-PLINK-SETTINGS"><span class="save-btn" (click)="checkChanges('plinkSettings')">{{'g.save'| translate}}</span></td>
									<td><span class="back-btn" (click)="setTab('CARDS'); resetForms();">{{'g.back'| translate}}</span></td>
								</tr>
							</table>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>

<div *ngIf="!hasPlinks || !userAccess">
	<div class="panel panel-default">
		<div class="panel-body">
			<p *ngIf="!hasPlinks">No PolarLink devices selected. Please select a device to manage settings.</p>
			<p *ngIf="!userAccess">You do not have permission to access PolarLink settings.</p>
		</div>
	</div>
</div>
